function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { getPage } from "services/templates-generator/api-service";
import Error from "next/error";
import { getGeneratorSystemConfigOnRequest, getPageConfigFromRequest, getPathFromRequest } from "server/services/request-service/request-service";
import { isMobile, isMobileOrTablet } from "server/services/aws-service/browser-service";
import { getAllAbTestsVariantsFromRequest, getHasFreeTierByRequest } from "/services/new-ab-tests/new-ab-tests-service";
import { AB_TEST_EXACT_EVENT_NAME, CLOUDFRONT_VIEWER_COUNTRY_HEADER } from "/constants/headers";
import { HAS_STUDENT_PLAN_INDICATION_COOKIE_NAME, HIDE_BANNER_WITH_BACKGROUND_COOKIE_NAME } from "constants/cookies";
import { getPricingVersion } from "services/pricing/pricing-model/services";
import { getGrantedFeatures } from "/services/cookies/granted-feature-cookie-service";
import { getOverrideParams } from "/services/query-params-service";
import { DYNAMIC_ASSET_PARAM, FORCE_CURRENCY, FORCE_PRICING, PREVENT_FREE_TIER_PARAM } from "constants/query-params";
import { getTranslationsFromApi } from "services/localization/localization-service";
import { getClustersConfig, parsePageLoadClusters } from "/services/clusters-service";
import { getHasStudentPlan } from "/services/pricing/pricing-model/student-service";
import { INTERNAL_SERVER_ERROR_CODE } from "constants/status-codes";
import { getPersistantServerCookiesFromRequest } from "server/services/cookies-server-service/cookies-server-service";
import { getSocialMetaTagsConfig } from "services/social-metatags-service";
import { getPricingPageConfig } from "services/pricing/pricing-page/pricing-page-config-service";
import { getCurrencyName } from "services/pricing-service";
import { getSignupDynamicAssetsLinks } from "server/signup/prefetch-signup-service";
import { handleServerException } from "server/services/exceptions-handling-service/exceptions-handling-service";
import { trackBigBrainEventOnServer } from "server/services/bigbrain-tracking-service/bigbrain-tracking-service";
const isObject = (obj)=>obj && typeof obj === "object";
export const getSerializedServerProps = (serverProps)=>Object.keys(serverProps).reduce((result, prop)=>{
        if (isObject(serverProps[prop])) {
            const objectKeys = Object.keys(serverProps[prop]);
            for(let i = 0; i < objectKeys.length; i++){
                const key = objectKeys[i];
                if (serverProps[prop][key] === undefined) {
                    delete serverProps[prop][key];
                }
            }
        }
        if (serverProps[prop]) {
            result[prop] = serverProps[prop];
        }
        return result;
    }, {});
const getPageConfigResultFromPath = function() {
    var _ref = _async_to_generator(function*(path, res) {
        const pageConfigResp = yield getPage(path);
        let errorCode = pageConfigResp.statusCode > 200 ? pageConfigResp.statusCode : null;
        const pageConfigRespJSON = yield pageConfigResp.json();
        const pageConfig = pageConfigRespJSON.pageConfig;
        if (!pageConfig && !errorCode) {
            res.statusCode = 404;
            errorCode = res.statusCode;
        }
        return {
            pageConfig,
            errorCode
        };
    });
    return function getPageConfigResultFromPath(path, res) {
        return _ref.apply(this, arguments);
    };
}();
export function getServerSideProps(context) {
    return _getServerSideProps.apply(this, arguments);
}
function _getServerSideProps() {
    _getServerSideProps = _async_to_generator(function*(context) {
        const executionStartTime = performance.now();
        const { req, res } = context;
        const { handleServerException } = require("../../server/services/exceptions-handling-service/exceptions-handling-service");
        let path = req.url;
        let translations = {};
        let pageConfig = null;
        let errorCode = null;
        let isMobileOrTabletBrowser = null;
        let isMobileBrowser = null;
        let isTypeformDisabled = null;
        let perceptionSurveyTests = null;
        let forcePricing = null;
        let forceCurrency = null;
        let localeToUse = null;
        let userSelectedLanguage = null;
        let abTestExactEventName = null;
        let cloudfrontViewerCountry = "";
        let hideBannerWithBackground = false;
        let grantedFeatures = null;
        let overrideParams = {}; // mind having them in the CDN cache
        let clusterConfig = {};
        let pageClusterConfig = null;
        let localizedPages = [];
        // req/res is undefined on back/forward navigation in Safari/Firefox.
        if (!req || !res) {
            if (window) {
                BigBrain("track", "back_forward_reload_in_mobile", {
                    kind: "force_reload"
                });
                window.location.reload();
            }
        }
        try {
            pageConfig = getPageConfigFromRequest(req);
            path = getPathFromRequest(req);
            isMobileOrTabletBrowser = isMobileOrTablet(req);
            isMobileBrowser = isMobile(req);
            localeToUse = req.localeToUse;
            userSelectedLanguage = req.userSelectedLocale;
            forcePricing = req.query && req.query[FORCE_PRICING];
            forceCurrency = req.query && req.query[FORCE_CURRENCY];
            hideBannerWithBackground = !!req.cookies[HIDE_BANNER_WITH_BACKGROUND_COOKIE_NAME];
            cloudfrontViewerCountry = res.getHeader(CLOUDFRONT_VIEWER_COUNTRY_HEADER);
            abTestExactEventName = res.getHeader(AB_TEST_EXACT_EVENT_NAME);
            const freeTierForcePrevent = req.query && req.query[PREVENT_FREE_TIER_PARAM];
            const hasStudentPlanCookie = req.cookies[HAS_STUDENT_PLAN_INDICATION_COOKIE_NAME];
            const hasStudentPlan = getHasStudentPlan({
                forcePricing,
                hasStudentPlanCookie
            });
            const hasFreeTier = getHasFreeTierByRequest(req);
            const generatorSystemConfig = getGeneratorSystemConfigOnRequest(req);
            isTypeformDisabled = generatorSystemConfig === null || generatorSystemConfig === void 0 ? void 0 : generatorSystemConfig.isTypeformDisabled;
            perceptionSurveyTests = generatorSystemConfig === null || generatorSystemConfig === void 0 ? void 0 : generatorSystemConfig.perceptionSurveyTests;
            grantedFeatures = getGrantedFeatures(req.cookies);
            if (!pageConfig) {
                const pageConfigResult = yield getPageConfigResultFromPath(path, res);
                pageConfig = pageConfigResult.pageConfig;
                errorCode = pageConfigResult.errorCode;
            }
            const abTestVariants = getAllAbTestsVariantsFromRequest(req);
            const { localeId } = pageConfig;
            translations = yield getTranslationsFromApi(localeId);
            overrideParams = getOverrideParams(req.query);
            const cookies = req.cookies;
            const { clusterId, subClusterId, clusterIdSource, subClusterIdSource } = parsePageLoadClusters(overrideParams, cookies, pageConfig);
            if (pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.fetchClusterConfig) {
                clusterConfig = yield getClustersConfig(clusterId, subClusterId, localeToUse);
            }
            const { pricingDefaults } = getPricingPageConfig();
            const pricingVersion = getPricingVersion({
                forcePricing,
                cookies,
                abTests: abTestVariants,
                currency: getCurrencyName({
                    forceCurrency,
                    pricingDefaults,
                    countryCode: cloudfrontViewerCountry
                }),
                isV13PricingVersion: pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.isV13PricingVersion
            });
            const isClusterMiniSitePage = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.clusterMiniSite;
            const useProductMiniSiteConfig = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.useProductMiniSiteConfig;
            const ignorePageClusterConfig = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.ignorePageClusterConfig;
            const pageProductId = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.pageProductId;
            const pageClusterId = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.clusterId;
            const pageSubClusterId = pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.subClusterId;
            if (!ignorePageClusterConfig && (!!pageClusterId || !!pageSubClusterId)) {
                pageClusterConfig = yield getClustersConfig(pageClusterId, pageSubClusterId, localeToUse);
            }
            const dynamicAssetParam = req === null || req === void 0 ? void 0 : req.query[DYNAMIC_ASSET_PARAM];
            const [facebookMetaOverride, twitterMetaOverride] = getSocialMetaTagsConfig(pageConfig, dynamicAssetParam);
            const persistantCookies = getPersistantServerCookiesFromRequest(req, res);
            // Set hreflangs to pages for SEO, using translations service
            // Only import on server side to avoid compiling errors
            const { getPageLocales } = require("server/services/translations-service/translations-service");
            const activeOriginalPagePath = req.path; // This is the path the user entered in the browswer, disregarding the ab-test fake redirect we do
            localizedPages = yield getPageLocales(activeOriginalPagePath);
            // signup prefetched assets
            // easy switch to turn dynamic assets prefetch off
            const shouldGetSignupPrefetchedAssets = true;
            let signupDynamicAssetsLinks = [];
            if (shouldGetSignupPrefetchedAssets) {
                signupDynamicAssetsLinks = yield getSignupDynamicAssetsLinks();
            }
            const props = {
                path,
                forcePricing: forcePricing,
                forceCurrency: forceCurrency,
                pageConfig,
                asPath: req.url,
                errorCode,
                isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                isMobileBrowser: isMobileBrowser,
                isTypeformDisabled: isTypeformDisabled,
                perceptionSurveyTests: perceptionSurveyTests,
                abTestVariants: abTestVariants,
                translations: translations,
                abTestExactEventName: abTestExactEventName,
                cloudfrontViewerCountry: cloudfrontViewerCountry,
                pricingVersion: pricingVersion,
                hasFreeTier: hasFreeTier,
                hasStudentPlan: hasStudentPlan,
                localeToUse: localeToUse,
                userSelectedLanguage: userSelectedLanguage,
                hideBannerWithBackground: hideBannerWithBackground,
                grantedFeatures: grantedFeatures,
                freeTierForcePrevent: freeTierForcePrevent,
                clusterId: clusterId,
                subClusterId: subClusterId,
                clusterIdSource: clusterIdSource,
                subClusterIdSource: subClusterIdSource,
                clusterConfig: clusterConfig,
                isClusterMiniSitePage: isClusterMiniSitePage,
                useProductMiniSiteConfig: useProductMiniSiteConfig,
                facebookMetaOverride: facebookMetaOverride,
                twitterMetaOverride: twitterMetaOverride,
                dynamicAssetParam: dynamicAssetParam,
                cookies: cookies,
                activePagePath: path,
                activeOriginalPagePath: activeOriginalPagePath,
                pageClusterConfig: pageClusterConfig,
                pageProductId: pageProductId,
                pageClusterId: pageClusterId,
                pageSubClusterId: pageSubClusterId,
                localizedPages: localizedPages,
                persistantCookies: persistantCookies,
                shouldGetSignupPrefetchedAssets: shouldGetSignupPrefetchedAssets,
                signupDynamicAssetsLinks: signupDynamicAssetsLinks
            };
            const executionEndTime = performance.now();
            const executionTime = (executionEndTime - executionStartTime).toFixed(2);
            trackBigBrainEventOnServer("gssp_executed", {
                kind: executionTime,
                info1: req.url
            });
            return {
                props: getSerializedServerProps(props)
            };
        } catch (e) {
            yield handleServerException({
                externalMessage: "Base template's page getInitialProps failed with an exception: ",
                e,
                req,
                res
            });
            res.statusCode = INTERNAL_SERVER_ERROR_CODE;
            return {
                props: {
                    errorCode: INTERNAL_SERVER_ERROR_CODE
                }
            };
        }
    });
    return _getServerSideProps.apply(this, arguments);
}
class BaseTemplatePage extends PureComponent {
    componentDidMount() {
        const { pageConfig } = this.props;
        // Track ab test if the landing page is in test.
        if (pageConfig && pageConfig.abTestVariant && pageConfig.abTestName) {
            BigBrain("track", pageConfig.abTestName, {
                ab_test: pageConfig.abTestVariant
            });
        }
    }
    render() {
        const { errorCode } = this.props;
        return /*#__PURE__*/ _jsx(Error, {
            statusCode: errorCode
        });
    }
}
export { BaseTemplatePage as default };
